import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Small } from 'foundations-components/transitional/components/Small';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import PropertyRecord from '../records/PropertyRecord';
import TaxonomyInputUtils from '../utils/TaxonomyInputUtils';
import { FUNNEL_STAGE } from '../constants/ConversationsProperties';
import { View } from 'foundations-components/components/View';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Select } from 'foundations-components/transitional/components/Select';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FunnelStageSelect = ({
  allProperties,
  currentValue = null,
  onChange,
  displayMode,
  ghosted = false
}) => {
  const renderOption = option => {
    return /*#__PURE__*/_jsxs(View, {
      paddingBlock: "200",
      paddingInline: "500",
      children: [/*#__PURE__*/_jsx("span", {
        children: option.text
      }), /*#__PURE__*/_jsx(Small, {
        use: "help",
        children: /*#__PURE__*/_jsx(TruncateString, {
          children: option.help
        })
      })]
    });
  };
  return /*#__PURE__*/_jsx(FormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "app.taxonomy.property.funnel.label"
    }),
    displayOptimized: displayMode === 'card',
    verticalSeparation: "flush",
    children: /*#__PURE__*/_jsx(Select, {
      "data-test-id": "funnel-stage-select-input",
      buttonUse: displayMode === 'panel' ? 'form' : undefined,
      paddingInlineStart: displayMode === 'card' ? '0' : undefined,
      menuWidth: displayMode === 'panel' ? 350 : 250,
      onChange: ({
        target: {
          value
        }
      }) => onChange(new PropertyRecord({
        name: FUNNEL_STAGE,
        value,
        revisionCode: currentValue ? currentValue.revisionCode : 0
      })),
      optionRenderer: option => renderOption(option),
      options: TaxonomyInputUtils.mapPropertiesToOptions({
        properties: allProperties,
        propertyKey: 'funnel',
        showHelp: true
      }),
      placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.taxonomy.property.funnel.placeholder"
      }),
      readOnly: ghosted,
      value: currentValue ? currentValue.value : null
    })
  });
};
FunnelStageSelect.propTypes = {
  allProperties: ImmutablePropTypes.list.isRequired,
  currentValue: PropTypes.instanceOf(PropertyRecord),
  displayMode: PropTypes.string.isRequired,
  ghosted: PropTypes.bool,
  onChange: PropTypes.func.isRequired
};
export default FunnelStageSelect;